import React from 'react';
import { cn } from 'utils/helpers';

interface ModalProps {
  open: boolean;
  title?: string;
  children?: React.ReactNode;
  isImageModal?: boolean;
  confirmText?: string;
  cancelText?: string;
  isProcessing?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const Modal: React.FC<ModalProps> = ({
  open,
  title,
  children,
  isImageModal,
  confirmText='Confirm',
  cancelText,
  isProcessing = false,
  onConfirm,
  onCancel,
  size = 'md',
}) => {
  if (!open) return null;
  
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-md',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className={cn(
        "relative bg-white rounded-xl shadow-xl w-full max-h-[90vh] overflow-y-auto p-4 sm:p-6",
        sizeClasses[size]
      )}>
        {title && <h3 className="text-base sm:text-lg font-semibold text-secondary-900 mb-3 sm:mb-4">{title}</h3>}
        {isImageModal&&(
        <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-3">
        <button
            type="button"
            className={cn(
              'px-4 py-2.5 mb-3 sm:py-2 rounded-lg text-white min-h-[44px] sm:min-h-[38px] touch-manipulation',
              isProcessing ? 'bg-primary-400 cursor-not-allowed' : 'bg-primary-600 hover:bg-primary-700'
            )}
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {confirmText}
          </button>
        </div>)}
        <div className="text-sm sm:text-base text-secondary-700 mb-4 sm:mb-6">{children}</div>
        <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-3">
          {cancelText && (
          <button
            type="button"
            className="px-4 py-2.5 sm:py-2 rounded-lg border border-secondary-300 text-secondary-700 hover:bg-secondary-50 min-h-[44px] sm:min-h-[38px] touch-manipulation"
            onClick={onCancel}
            disabled={isProcessing}
          >
            {cancelText}
          </button>
          )}
          {!isImageModal&&(
          <button
            type="button"
            className={cn(
              'px-4 py-2.5 sm:py-2 rounded-lg text-white min-h-[44px] sm:min-h-[38px] touch-manipulation',
              isProcessing ? 'bg-primary-400 cursor-not-allowed' : 'bg-primary-600 hover:bg-primary-700'
            )}
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {confirmText}
          </button>)}
        </div>
      </div>
    </div>
  );
};

export default Modal;


